import { useEffect, useReducer } from "react";
import { fetchMemberList, fetchTaskList } from "services/task";
import { getNumberVal, jsonToMarkdown } from "utils/function";
import { useLocation } from "react-router-dom";
import { createEvent, updateEvent } from "services/event";
import { getFeteFormatByValue } from "utils/fete";
import { llmAgentConversationRetrival, llmAgentInstruction, llmCreateRAG, llmDeleteRAG, llmUpdateRAG } from "services/llm";
import { getLLMAgentConversationRetrivalPayload, getLLMAgentInstructPayload } from "services/llm/payloads";
import { DEFAULT_FETEBUDDY_INITIATE_MESSAGES, DEFAULT_FETEBUDDY_PROMPT_KEYS, MESSAGE_TYPES } from "constants/llm";
import { getAnswerFromResponse, getFormattedHistory } from "utils/llm";
import { addNewMessage } from "services/chat";
import { has, isEmpty } from "lodash";
import { EVENT_DEFAULTS } from "utils/constant";

const initialArgs = {
  showAssignModal: false,
  showDueDateModal: false,
  showRemainderModal: false,
  showUploadFileModal: false,
  cardPrompt: '',
  currentSession: null,
  userChatSessions: [],
  initNewFete: false,
};

const reducer = (state: any, action: any) => {
  return { ...state, ...action };
};

const useChatHook = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const location = useLocation();

  const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

  const fetchTaskListService = async (payload: any) => {
    try {
      const response = await fetchTaskList(payload);
      return response?.data.length > 0 ? response?.data[0].tasks : [] || []
    } catch (error) {
      console.log("Error while fetching the task list =", error);
    }
  };

  const getNewFetePayload = (newFeteDetails: any) => {
    return {
      name: newFeteDetails?.event_title || EVENT_DEFAULTS.title,
      locations: newFeteDetails?.event_location ? [newFeteDetails?.event_location] : null,
      start_date: newFeteDetails?.event_start_date ? Date.parse(newFeteDetails?.event_start_date) : null,
      end_date: newFeteDetails?.event_end_date ? Date.parse(newFeteDetails?.event_end_date) : null,
      objective: newFeteDetails?.event_objective ? newFeteDetails?.event_objective : null,
      type: newFeteDetails?.event_type ? newFeteDetails?.event_type : null,
      format: newFeteDetails?.event_format ? getFeteFormatByValue(newFeteDetails?.event_format) : 0,
      budget: {
        min: newFeteDetails?.event_minimum_budget ? newFeteDetails?.event_minimum_budget : null,
        max: newFeteDetails?.event_maximum_budget ? newFeteDetails?.event_maximum_budget : null,
      },
      attendees: {
        min: newFeteDetails?.event_minimum_number_of_attendees ? newFeteDetails?.event_minimum_number_of_attendees : null,
        max: newFeteDetails?.event_maximum_number_of_attendees ? newFeteDetails?.event_maximum_number_of_attendees : null,
      },
      team_id: currentTeam?.currentTeamId,
      session_id: newFeteDetails?.session_id,
      is_draft: true,
      accomodation: newFeteDetails?.accomodation ? true : false,
    }
  }

  const getEventDetails = (event: any) => {
    return {
      name: event?.name,
      objective: event?.objective,
      start_date: event?.start_date,
      end_date: event?.end_date,
      budget: event?.budget,
      attendees: event?.attendees,
      locations: event?.locations,
      type: event?.type,
      format: event?.format
    }
  }

  const createNewEvent = async (newFeteDetails: any) => {
    try {
      return await createEvent(getNewFetePayload(newFeteDetails))
    } catch (error) {
      console.error('CREATE EVENT ERROR::', error);
    }
  }

  const getAddiotionalFeteInfo = (additional: any) => {
    const keys = Object.keys(additional);
    const outputArray = keys.map(key => {
      return { [key]: additional[key] };
    });
    return outputArray;
  }


  const getUpdateEventPayload = (newFeteDetails: any) => {
    return {
      name: newFeteDetails?.event_title ? newFeteDetails?.event_title : null,
      locations: newFeteDetails?.event_location ? [newFeteDetails?.event_location] : null,
      start_date: newFeteDetails?.event_start_date ? newFeteDetails?.event_start_date : null,
      end_date: newFeteDetails?.event_end_date ? newFeteDetails?.event_end_date : null,
      times: newFeteDetails?.times ? newFeteDetails?.times : [],
      objective: newFeteDetails?.event_objective ? newFeteDetails?.event_objective : null,
      type: newFeteDetails?.event_type ? newFeteDetails?.event_type : null,
      format: newFeteDetails?.event_format ? getFeteFormatByValue(newFeteDetails?.event_format) : null,
      budget: {
        min: newFeteDetails?.event_minimum_budget ? getNumberVal(newFeteDetails?.event_minimum_budget) : null,
        max: newFeteDetails?.event_maximum_budget ? getNumberVal(newFeteDetails?.event_maximum_budget) : null,
      },
      attendees: {
        min: newFeteDetails?.event_minimum_number_of_attendees ? getNumberVal(newFeteDetails?.event_minimum_number_of_attendees) : null,
        max: newFeteDetails?.event_maximum_number_of_attendees ? getNumberVal(newFeteDetails?.event_maximum_number_of_attendees) : null,
      },
      is_draft: newFeteDetails?.is_draft || false,
      tasks: newFeteDetails?.additional ? getAddiotionalFeteInfo(newFeteDetails?.additional) : [],
      time_zone: newFeteDetails?.event_time_zone ? newFeteDetails?.event_time_zone : null,
      accomodation: newFeteDetails?.accomodation ? true : false
    }
  }

  const updateExistingEvent = async (eventId: string, eventPayload: any) => {
    try {
      return await updateEvent(eventId, getUpdateEventPayload(eventPayload))
    } catch (error) {
      console.error('UPDATE EVENT ERROR::', error);
    }
  }

  const getLLMPayload = ({
    userMessage, promptKey, session_id, metadata_filter, newFeteDetails, input_variables
  }: any) => {
    const inputVars: any = {
      ...input_variables,
      "question": userMessage
    }
    // if(!metadata_filter?.['is_draft']) {
    //   metadata_filter['is_draft'] = false;
    // }
    // if(!has(metadata_filter,'is_draft')){
    //   metadata_filter['is_draft'] = false;
    // }
    if (promptKey === DEFAULT_FETEBUDDY_PROMPT_KEYS.START && newFeteDetails && metadata_filter?.is_draft === true) {
      inputVars['extractedEventDetails'] = jsonToMarkdown(newFeteDetails)
    }
    // For vendor filteration
    if (metadata_filter?.isVendor) {
      metadata_filter = {}
    }
    return getLLMAgentConversationRetrivalPayload({
      prompt_key: promptKey,
      metadata_filter: metadata_filter,
      input_variables: inputVars,
      session_id: session_id
    })
  }

  const addUserMessage = async (message: string, session_id: string) => {
    try {
      let shouldIgnore = false;
      Object.keys(DEFAULT_FETEBUDDY_INITIATE_MESSAGES).map(key => {
        if (DEFAULT_FETEBUDDY_INITIATE_MESSAGES[key] === message) {
          shouldIgnore = true;
        }
      })
      if (!shouldIgnore && message && !isEmpty(message)) {
        await addNewMessage({ content: message, type: MESSAGE_TYPES.HUMAN, session_id })
      }
    } catch (error) {
      console.error('Add User message err::', error);
    }
  }

  const addAIMessage = async (message: string, session_id: string) => {
    try {
      if (message && !isEmpty(message)) {
        await addNewMessage({ content: message, type: MESSAGE_TYPES.AI, session_id })
      }
    } catch (error) {
      console.error('Add User message err::', error);
    }
  }

  const getLLMResponse = async ({
    userMessage, promptKey, session_id, metadata_filter, newFeteDetails = null, input_variables = {}
  }: any) => {
    try {
      await addUserMessage(userMessage, session_id)
      const { data } = await llmAgentConversationRetrival(
        getLLMPayload({
          userMessage, promptKey, session_id, metadata_filter, newFeteDetails, input_variables
        })
      );
      await addAIMessage(getAnswerFromResponse(data), session_id);
      return data;
    } catch (error) {
      console.error('getLLMResponse ERROR::', error);
    }
  }

  const fetchMemberListService = async (payload: any) => {
    try {
      const response = await fetchMemberList(payload);
      return response?.data || [];
    } catch (error) {
      console.log("Error while fetching the task list =", error);
    }
  };

  const resetStateToDefaults = () => {
    setState({ ...state, newFeteDetails: null })
  }

  useEffect(() => {
    resetStateToDefaults();
  }, [location.pathname]);

  const getNewTitleForSession = async ({
    chat_history, context, session_id
  }: any) => {
    const { data } = await llmAgentInstruction(getLLMAgentInstructPayload({
      prompt_key: DEFAULT_FETEBUDDY_PROMPT_KEYS.GENERATE_SESSION_TITLE,
      input_variables: {
        "context": context,
        "chat_history": getFormattedHistory(chat_history),
      }
    }));
    let generatedText = getAnswerFromResponse(data);
    if (generatedText?.includes(`"`)) {
      generatedText = generatedText.match(/"([^"]*)"/)[1]; // This is for converting ""Test"" to "Test"
    }
    return generatedText;
  }

  const createRAGEntryOfFete = async (payload: any) => {
    await llmCreateRAG(payload)
  }

  const updateRAGEntryOfFete = async (payload: any) => {
    await llmUpdateRAG(payload)
  }

  const deleteRAGEntryOfFete = async (payload: any) => {
    await llmDeleteRAG(payload)
  }

  return {
    fetchTaskListService,
    fetchMemberListService,
    resetStateToDefaults,
    getLLMResponse,
    createNewEvent,
    getNewTitleForSession,
    getEventDetails,
    ...state,
    setState,
    createRAGEntryOfFete,
    updateExistingEvent,
    updateRAGEntryOfFete,
    deleteRAGEntryOfFete
  };
};

export default useChatHook;
